import { render, staticRenderFns } from "./PasswordResetLink.vue?vue&type=template&id=65f53c1b&"
import script from "./PasswordResetLink.vue?vue&type=script&lang=js&"
export * from "./PasswordResetLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports